import axios from "axios";
import { BASE_URL, API_BASE_URL, CDP_DETAILS_API,SAVE_CDP_DETAILS_API } from "../constants/Constants";

export const getCdpDataService = async (supplierId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/${CDP_DETAILS_API}/${supplierId}`,
    {
      headers: {
      Authorization:`Bearer ${sessionStorage.getItem("authToken")}`,
        'Content-Type': 'application/json', 
      },
  });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const saveCdpDataService = async (cdpData,supplierId) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/${SAVE_CDP_DETAILS_API}/${supplierId}`, cdpData, {
      headers: {
        Authorization:`Bearer ${sessionStorage.getItem("authToken")}`,
        'Content-Type': 'application/json', 
      },
    });
    return response.data; 
  } catch (error) {
    throw error;
  }
};